import {call, put} from "redux-saga/effects";
import {getReseUserTableData, getReseUserTableDistinctColumnData, updateReseUserTableData} from "../components/rese/rese-users/ReseUserService";
import { getReseUserTableDataSuccess, getReseUserTableDataError, getReseUserTableDivisionSuccess, getReseUserTableDivisionError,getReseUserTableStoreSuccess, getReseUserTableStoreError,
getReseUserTableBannerSuccess,getReseUserTableBannerError, getReseUserTableStatusSuccess, getReseUserTableStatusError,
updateReseUserTableDataSuccess, updateReseUserTableDataError,getReseUserTableDataInit } from "../components/rese/rese-users/redux/actions";

export function* loadReseUserTableData ({pageNumber, pageSize, sortBy, sortDirection, filterCondition}) {
    try {
        const reseUserData = yield call(getReseUserTableData,pageNumber, pageSize, sortBy, sortDirection, filterCondition);
        yield put(getReseUserTableDataSuccess(reseUserData));
    } catch (error) {
        yield put(getReseUserTableDataError(error.toString()));
    }
}

export function* loadReseUserTableDivisionData ({divisionColumnPayload}) {
    try {
        const divisionData = yield call(getReseUserTableDistinctColumnData, divisionColumnPayload);
        yield put(getReseUserTableDivisionSuccess(divisionData));
    } catch (error) {
        yield put(getReseUserTableDivisionError(error.toString()));
    }
}
export function* loadReseUserTableStoreData ({storeColumnPayload}) {
    try {
        const storeData = yield call(getReseUserTableDistinctColumnData, storeColumnPayload);
        yield put(getReseUserTableStoreSuccess(storeData));
    } catch (error) {
        yield put(getReseUserTableStoreError(error.toString()));
    }
}
export function* loadReseUserTableBannerData ({bannerColumnPayload}) {
    try {
        const bannerData = yield call(getReseUserTableDistinctColumnData, bannerColumnPayload);
        yield put(getReseUserTableBannerSuccess(bannerData));
    } catch (error) {
        yield put(getReseUserTableBannerError(error.toString()));
    }
}





export function* loadReseUserTableStatusData ({statusColumnPayload}) {
    try {
        const statusData = yield call(getReseUserTableDistinctColumnData, statusColumnPayload);
        yield put(getReseUserTableStatusSuccess(statusData));
    } catch (error) {
        yield put(getReseUserTableStatusError(error.toString()));
    }
}

export function* updateReseUserTable ({tableData}) {
    try {
        const updatedData = yield call(updateReseUserTableData, tableData);
        yield put(updateReseUserTableDataSuccess(updatedData));
        yield put(getReseUserTableDataInit(0, 10, "firstName", "ASC", ""));
    } catch (error) {
        yield put(updateReseUserTableDataError(error.toString()));
    }
}